import { defineStore } from 'pinia'

interface IState {
  id: symbol | null
  data: string[]
}

export const useScannerStore = defineStore('scanner', {
  state: (): IState => ({
    id: null,
    data: [],
  }),
  actions: {
    setId(id: symbol) {
      this.id = id
    },
    setData(arr: string[]) {
      this.data = arr
    },
  },
})
